/**
 * PATH: packages/ui/src/kanban/components/RightRailPhoneSheetHandle.tsx
 * FILE_ID: UI-KANBAN-RIGHT-RAIL-PHONE-HANDLE-001
 * PURPOSE: Phone sheet grabber + a always-visible X for Emails / Jobs / Card.
 * WHY: Card already showed an X; Emails and Jobs hid theirs when the
 *   in-tree header clipped. One handle row keeps dismiss identical.
 */
import { X } from 'lucide-react'

export interface RightRailPhoneSheetHandleProps {
  onClose: () => void
  closeAriaLabel: string
}

export function RightRailPhoneSheetHandle({
  onClose,
  closeAriaLabel,
}: RightRailPhoneSheetHandleProps) {
  return (
    <div
      data-right-rail-phone-handle=""
      className="relative flex min-h-[44px] w-full items-center justify-center md:hidden"
    >
      <button
        type="button"
        aria-label={`${closeAriaLabel} handle`}
        onClick={onClose}
        className="flex min-h-[44px] w-full items-center justify-center md:min-h-0 md:h-4"
      >
        <span
          className="block h-1 w-10 rounded-full bg-neutral-300 dark:bg-zinc-700"
          aria-hidden="true"
        />
      </button>
      <button
        type="button"
        aria-label={closeAriaLabel}
        title="Close"
        onClick={onClose}
        className="absolute right-1 inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-lg text-neutral-500 hover:bg-neutral-100 hover:text-neutral-800 dark:text-zinc-400 dark:hover:bg-zinc-800"
      >
        <X className="h-5 w-5" aria-hidden="true" />
      </button>
    </div>
  )
}
